module.exports = __webpack_public_path__ + "img/9788983947994.08891173.jpg";